import { HashRouter, Routes, Route } from "react-router-dom";
import AccountDetails from "../pages/common/AccountDetails";
import PasswordRecovery from "../pages/common/PasswordRecovery";
import Register from "../pages/common/Register";
import ComercialAppointments from "../pages/petAndBeauty/Comercial/Appointments";
import AddEmployee from "../pages/petAndBeauty/Comercial/EmployeesPages/AddEmployee";
import EditEmployee from "../pages/petAndBeauty/Comercial/EmployeesPages/EditEmployee";
import EmployeeView from "../pages/petAndBeauty/Comercial/EmployeesPages/EmployeeView";
import Employees from "../pages/petAndBeauty/Comercial/EmployeesPages/Employees";
import MyWorkscales from "../pages/petAndBeauty/Comercial/MyWorkscales";
import AddService from "../pages/petAndBeauty/Comercial/ServicesPages/AddService";
import EditService from "../pages/petAndBeauty/Comercial/ServicesPages/EditService";
import ServiceDetails from "../pages/petAndBeauty/Comercial/ServicesPages/ServiceDetails";
import ServicesPage from "../pages/petAndBeauty/Comercial/ServicesPages/ServicesPage";
import AddStore from "../pages/petAndBeauty/Comercial/StoresPages/AddStore";
import EditStore from "../pages/petAndBeauty/Comercial/StoresPages/EditStore";
import Stores from "../pages/petAndBeauty/Comercial/StoresPages/Stores";
import CartPayment from "../pages/petAndBeauty/Client/CartPayment";
import ClientAppointments from "../pages/petAndBeauty/Client/ClientAppointments";
import EmployeePage from "../pages/petAndBeauty/Client/EmployeePage";
import ScheduilingPage from "../pages/petAndBeauty/Client/ScheduilingPage";
import SearchPage from "../pages/petAndBeauty/Client/SearchPage";
import ServicePage from "../pages/petAndBeauty/Client/ServicePage";
import StorePage from "../pages/petAndBeauty/Client/StorePage";
import PetLandingPage from "../pages/petAndBeauty/LandingPages/pet";
import { DEMANDORIA_SUBDOMAINS, CURRENT_SUBDOMAIN } from "../utils/stringUtils";
import Home from "../pages/common/Home";
import ShoppingCart from "../pages/common/ShoppingCart";
import Login from "../pages/common/Login";
import BeautyLandingPage from "../pages/petAndBeauty/LandingPages/beauty";
import StoreDetails from "../pages/petAndBeauty/Comercial/StoresPages/StoreDetails";
import ManagerStoresProvider from "../context/ManagerStores/provider";
import ProtectedComponent from "@/components/general/ProtectedComponent";
import Finances from "@/pages/petAndBeauty/Comercial/StoresPages/Finances";

const petAndBeautyClientRoutes = (
  <>
    <Route
      path="/stores"
      element={
        <ManagerStoresProvider>
          <Stores />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/stores/add"
      element={
        <ManagerStoresProvider>
          <AddStore />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/stores/edit"
      element={
        <ManagerStoresProvider>
          <EditStore />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/stores/details"
      element={
        <ManagerStoresProvider>
          <StoreDetails />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/services"
      element={
        <ManagerStoresProvider>
          <ServicesPage />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/services/add"
      element={
        <ManagerStoresProvider>
          <AddService />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/services/edit"
      element={
        <ManagerStoresProvider>
          <EditService />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/services/details"
      element={
        <ManagerStoresProvider>
          <ServiceDetails />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/employees"
      element={
        <ManagerStoresProvider>
          <Employees />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/employees/add"
      element={
        <ManagerStoresProvider>
          <AddEmployee />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/employees/edit"
      element={
        <ManagerStoresProvider>
          <EditEmployee />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/employees/details"
      element={
        <ManagerStoresProvider>
          <EmployeeView />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/my-workscales"
      element={
        <ManagerStoresProvider>
          <MyWorkscales />
        </ManagerStoresProvider>
      }
    />
    <Route
      path="/appointments"
      element={
        <ManagerStoresProvider>
          <ComercialAppointments />
        </ManagerStoresProvider>
      }
    />
    <Route path="/finance" element={<ManagerStoresProvider><Finances /></ManagerStoresProvider>}/>
    <Route path="/search" element={<SearchPage />} />
    <Route path="/store" element={<StorePage />} />
    <Route path="/service" element={<ServicePage />} />
    <Route path="/my-appointments" element={<ClientAppointments />} />
    <Route path="/employee" element={<EmployeePage />} />
    <Route path="/scheduiling" element={<ScheduilingPage />} />
    <Route path="/payment" element={<CartPayment />} />
  </>
);

const AppRoutes = () => {
  return (
    <HashRouter>
      <Routes>
        {CURRENT_SUBDOMAIN === DEMANDORIA_SUBDOMAINS[0] ? (
          <>
            {petAndBeautyClientRoutes}
            <Route path="/" element={<BeautyLandingPage />} />
          </>
        ) : (
          <>
            {petAndBeautyClientRoutes}
            <Route path="/" element={<PetLandingPage />} />
          </>
        )}

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/password-recovery" element={<PasswordRecovery />} />

        <Route path="" element={<ProtectedComponent />}>
          <Route path="/home" element={<Home />} />
          <Route path="/user/details" element={<AccountDetails />} />
          <Route path="/cart" element={<ShoppingCart />} />
          <Route path="/cart/payment" element={<CartPayment />} />
        </Route>
      </Routes>
    </HashRouter>
  );
};

export default AppRoutes;
